var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8326_3709)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6525 20.4831V26.2747L15.6802 28.2053V20.4831L11.708 14.6914H23.6247L19.6525 20.4831Z",
    stroke: "#41BA8F",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77783 8.90278H33.5556M7.73617 -0.75V5.04167M17.6667 -0.75V5.04167M27.5973 -0.75V5.04167M31.5695 3.11111H3.76394C2.66562 3.11111 1.77783 3.976 1.77783 5.04167V32.0694C1.77783 33.1351 2.66562 34 3.76394 34H31.5695C32.6678 34 33.5556 33.1351 33.5556 32.0694V5.04167C33.5556 3.976 32.6678 3.11111 31.5695 3.11111Z",
    stroke: "#41BA8F",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8326_3709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCalendar);
export default __webpack_public_path__ + "static/media/filterCalendar.2db243aae1178283499c6c38845c4251.svg";
export { ForwardRef as ReactComponent };